import { Socket } from 'socket.io-client';

import { ModelVersion } from '@verantos-dev/app-state-research-assistant';
import { transformUser } from '@verantos-dev/core-auth';
import { IVerantosUser } from '@verantos-dev/types-common';

export const emitSubscribeToCohort = (
  socket: Socket,
  projectId: string,
  cohortId: string,
  cohortVersionId: string | undefined,
  model: ModelVersion,
  isOwner: boolean,
  user: IVerantosUser,
  reconnecting: boolean,
  messages: any[]
) => {
  socket.emit('subscribe', {
    model,
    data: {
      isOwner,
      cohortVersionId,
      cohortId,
      projectId,
      userInfo: transformUser(user),
      reconnecting,
      messages,
    },
  });
};
